import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Demo mode: active when credentials are missing or still contain placeholder values
const isPlaceholder =
  !supabaseUrl ||
  !supabaseAnonKey ||
  supabaseUrl.includes('your-project-id') ||
  supabaseAnonKey.includes('your-anon-key');

export const isDemoMode = isPlaceholder;

export const supabase = isPlaceholder
  ? null
  : createClient(supabaseUrl, supabaseAnonKey);
